var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.fullView ? 'full-view' : 'variations-per-stage-echarts'},[_c('v-chart',{ref:"chartRef",staticClass:"chart",attrs:{"option":_vm.option,"init-options":{ renderer: 'svg' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }